import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, enableMultiTabIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDmPEFGKjFaI9ZTZ5d7i2EOHqQlCca0yjg",
  authDomain: "drmasr-5eeb1.firebaseapp.com",
  projectId: "drmasr-5eeb1",
  storageBucket: "drmasr-5eeb1.firebasestorage.app",
  messagingSenderId: "688572901989",
  appId: "1:688572901989:web:9ec82831ed0922b2f5348c",
  measurementId: "G-HGHGL7JZ1N"
};

const app = initializeApp(firebaseConfig);
const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;
const db = getFirestore(app);
const auth = getAuth(app);

// Enable Offline Persistence for robust local-first experience
try {
  enableMultiTabIndexedDbPersistence(db).catch((err) => {
      if (err.code == 'failed-precondition') {
          console.warn("Firestore persistence failed: multiple tabs open.");
      } else if (err.code == 'unimplemented') {
          console.warn("Firestore persistence is not supported in this browser.");
      }
  });
} catch(e) {
  console.error("Offline config error:", e);
}

export { app, analytics, db, auth };
